import { Glass } from "@coach/ui";

export function AnalyticsPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-display-md font-semibold tracking-tight">Teamanalyse</h1>
      <Glass padding="lg">
        <p className="text-body-md text-muted-foreground">
          Aggregated heat-maps and progression charts land in Phase&nbsp;4.
        </p>
      </Glass>
    </div>
  );
}
